import React, { useState } from 'react';
import styled from 'styled-components';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Loading from './components/Loading';
import WorkoutList from './components/WorkoutList';
import WorkoutItem from './components/WorkoutItem';

import * as crossService from './services/cross';

const Container = styled.div`
  margin: auto;
  max-width: 1200px;
  position: relative;
  height: 100%;
`;

function App() {
  const [workouts, setWorkouts] = useState<crossService.Programme[]>([]);
  const hasWorkouts = workouts.length > 0;

  React.useEffect(() => {
    const fetchData = async () => {
      const programmes = await crossService.GetProgrammes();

      setWorkouts(programmes);
    };

    fetchData();
  }, [setWorkouts]);

  return (
    <Container>
      <BrowserRouter>
        <Route render={({ location }) => (
          <AnimatePresence exitBeforeEnter={true}>
            {!hasWorkouts &&
              <Loading />
            }
            {hasWorkouts &&
              <Switch location={location} key={location.pathname}>
                <Route exact path="/:id" key="WorkoutItem">
                  <WorkoutItem programmes={workouts} />
                </Route>
                <Route exact path="/" key="WorkoutList">
                  <WorkoutList programmes={workouts} />
                </Route>
                <Route path="*">Page not found</Route>
              </Switch>
            }
          </AnimatePresence>
        )}/>
      </BrowserRouter>
    </Container>
  );
}

export default App;